window.custErrors = {
    TEHNICAL: 'Техническая ошибка',
}